import React from 'react';

// relements
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Tooltip from 'relements/build/esm/overlays/tooltip';
import InfoIconV4 from 'relements/build/esm/ui/icons/InfoIconV4';

const Label = ({ text, marginTop = 0, marginBottom = 0, info = '' }) => {
  return (
    <Box padding="0">
      <Text
        color="text"
        variant="h3.semi-bold"
        style={{ marginTop, marginBottom }}
      >
        {text}
      </Text>
      <Tooltip themed tooltip={info} position="TOP">
        <InfoIconV4 size="small" iconColor="grey.dark" marginLeft="4px" />
      </Tooltip>
    </Box>
  );
};

export default Label;
